'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _semanticUiReact = require('semantic-ui-react');

var _reactCsv = require('react-csv');

var _DayPickerInput = require('react-day-picker/DayPickerInput');

var _DayPickerInput2 = _interopRequireDefault(_DayPickerInput);

require('react-day-picker/lib/style.css');

var _moment3 = require('react-day-picker/moment');

var _roiReport = require('../roi-report');

var _formatting = require('../../utils/formatting');

var _emvUtils = require('../../utils/emv-utils');

var _reportHeader = require('../../reports/report-header');

var _reportHeader2 = _interopRequireDefault(_reportHeader);

var _summaryTable = require('./summary-table');

var _summaryTable2 = _interopRequireDefault(_summaryTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasNoAssets = function hasNoAssets(array) {
  return _lodash2.default.isUndefined(_lodash2.default.find(array, function (i) {
    return i > 0;
  }));
};

var DATE_PICKER_DATE_FORMAT = 'DD/MM/YYYY';

var tableStyle = { marginBottom: 0 };
var boldFontStyle = { fontWeight: 'bold' };
var totalRowStyle = (0, _extends3.default)({}, boldFontStyle, {
  background: '#eee'
});
var avatarStyle = {
  width: 50,
  height: 50,
  float: 'left'
};

var influencerNameStyle = {
  fontSize: 16,
  marginLeft: 8,
  marginBottom: -4,
  marginTop: 4,
  float: 'left'
};

var influnecerHandleStyle = {
  marginLeft: 8,
  marginTop: 3,
  float: 'left',
  color: 'gray'
};

var HELP_LINK = 'https://help.dyzio.co/campaign-reports/roi-report';
var goToHelpPage = function goToHelpPage() {
  return window.open(HELP_LINK, '_blank');
};

var hostname = _lodash2.default.toLower(window.location.hostname);
var isVoxogram = hostname.match(/voxogram/);

var TotalsRow = function TotalsRow(_ref) {
  var rows = _ref.rows;

  var reachTotal = _lodash2.default.sumBy(_lodash2.default.values(rows), function (row) {
    return _lodash2.default.get(row, 'totals.reach');
  });
  var impressionsTotal = _lodash2.default.sumBy(_lodash2.default.values(rows), function (row) {
    return _lodash2.default.get(row, 'totals.impressions');
  });
  var engagementsTotal = _lodash2.default.sumBy(_lodash2.default.values(rows), function (row) {
    return _lodash2.default.get(row, 'totals.engagements');
  });
  var videoViewsTotal = _lodash2.default.sumBy(_lodash2.default.values(rows), function (row) {
    return _lodash2.default.get(row, 'totals.videoViews');
  });
  return _react2.default.createElement(
    _semanticUiReact.Table.Row,
    { textAlign: 'center', style: totalRowStyle },
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'left' },
      _react2.default.createElement(
        'b',
        null,
        'Totals'
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'left' },
      '-'
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      '-'
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'span',
          null,
          (0, _formatting.commaFormatted)(reachTotal)
        ),
        content: 'Sum of total reach'
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'span',
          null,
          (0, _formatting.commaFormatted)(impressionsTotal)
        ),
        content: 'Sum of total impressions'
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'span',
          null,
          (0, _formatting.commaFormatted)(videoViewsTotal)
        ),
        content: 'Sum of total views'
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'span',
          null,
          (0, _formatting.commaFormatted)(engagementsTotal)
        ),
        content: 'Sum of total engagements'
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      '-'
    )
  );
};

TotalsRow.propTypes = {
  rows: _propTypes2.default.any.isRequired
};

var twoRowsModeArrowStyle = {
  color: 'orange',
  fontWeight: 'bold',
  display: 'block',
  float: 'right',
  marginLeft: -22,
  marginTop: -8,
  marginRight: -10
};

var oneRowModeArrowStyle = (0, _extends3.default)({}, twoRowsModeArrowStyle, {
  marginTop: 3
});

var SortArrow = function SortArrow(_ref2) {
  var field = _ref2.field,
      order = _ref2.order,
      targetField = _ref2.targetField,
      twoRowsMode = _ref2.twoRowsMode;

  var shouldRenderIcon = _lodash2.default.eq(field, targetField);
  if (shouldRenderIcon) {
    return _react2.default.createElement(_semanticUiReact.Icon, {
      name: 'angle ' + (order === 'asc' ? 'up' : 'down'),
      style: twoRowsMode ? twoRowsModeArrowStyle : oneRowModeArrowStyle
    });
  }
  return null;
};

SortArrow.propTypes = {
  field: _propTypes2.default.string.isRequired,
  order: _propTypes2.default.oneOf(['asc', 'desc']).isRequired,
  targetField: _propTypes2.default.string.isRequired,
  twoRowsMode: _propTypes2.default.boolean
};

SortArrow.defaultProps = {
  twoRowsMode: false
};

var ReportTableHeader = function ReportTableHeader(_ref3) {
  var onSortChanged = _ref3.onSortChanged,
      sort = _ref3.sort;
  return _react2.default.createElement(
    _semanticUiReact.Table.Header,
    null,
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        onClick: function onClick() {
          return onSortChanged('name');
        }
      },
      'influencer ',
      _react2.default.createElement(SortArrow, (0, _extends3.default)({ targetField: 'name' }, sort))
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        onClick: function onClick() {
          return onSortChanged('trackedAssetsStats.totalAssets');
        }
      },
      'assets ',
      _react2.default.createElement(SortArrow, (0, _extends3.default)({ targetField: 'trackedAssetsStats.totalAssets' }, sort))
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        onClick: function onClick() {
          return onSortChanged('instagramCount');
        },
        textAlign: 'center'
      },
      'total ',
      _react2.default.createElement('br', null),
      'followers ',
      _react2.default.createElement(SortArrow, (0, _extends3.default)({ twoRowsMode: true, targetField: 'instagramCount' }, sort))
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        onClick: function onClick() {
          return onSortChanged('totals.reach');
        },
        textAlign: 'center'
      },
      'total ',
      _react2.default.createElement('br', null),
      'reach ',
      _react2.default.createElement(SortArrow, (0, _extends3.default)({ twoRowsMode: true, targetField: 'totals.reach' }, sort))
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        onClick: function onClick() {
          return onSortChanged('totals.impressions');
        },
        textAlign: 'center'
      },
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'span',
          null,
          'total ',
          _react2.default.createElement('br', null),
          'imps',
          _react2.default.createElement(SortArrow, (0, _extends3.default)({ twoRowsMode: true, targetField: 'totals.impressions' }, sort))
        ),
        content: 'total impressions'
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        onClick: function onClick() {
          return onSortChanged('totals.videoViews');
        },
        textAlign: 'center'
      },
      'video ',
      _react2.default.createElement('br', null),
      'views ',
      _react2.default.createElement(SortArrow, (0, _extends3.default)({ twoRowsMode: true, targetField: 'totals.videoViews' }, sort))
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        onClick: function onClick() {
          return onSortChanged('totals.engagements');
        },
        textAlign: 'center'
      },
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'span',
          null,
          'total ',
          _react2.default.createElement('br', null),
          'engs ',
          _react2.default.createElement(SortArrow, (0, _extends3.default)({ twoRowsMode: true, targetField: 'totals.engagements' }, sort))
        ),
        content: _react2.default.createElement(
          'span',
          null,
          'total engagements:',
          _react2.default.createElement('br', null),
          ' likes + comments'
        )
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.HeaderCell,
      {
        onClick: function onClick() {
          return onSortChanged('instagramEngagementFactor');
        },
        textAlign: 'center'
      },
      _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(
          'span',
          null,
          'engs ',
          _react2.default.createElement('br', null),
          'rate ',
          _react2.default.createElement(SortArrow, (0, _extends3.default)({ twoRowsMode: true, targetField: 'instagramEngagementFactor' }, sort))
        ),
        content: _react2.default.createElement(
          'span',
          null,
          'average engagements / followers count * 100'
        )
      })
    )
  );
};

ReportTableHeader.propTypes = {
  onSortChanged: _propTypes2.default.func.isRequired,
  sort: _propTypes2.default.object.isRequired
};

var ReportRow = function ReportRow(_ref4) {
  var id = _ref4.id,
      name = _ref4.name,
      thumbnail = _ref4.thumbnail,
      influencerName = _ref4.influencerName,
      instagramCount = _ref4.instagramCount,
      instagramEngagementFactor = _ref4.instagramEngagementFactor,
      _ref4$totals = _ref4.totals,
      reach = _ref4$totals.reach,
      impressions = _ref4$totals.impressions,
      engagements = _ref4$totals.engagements,
      videoViews = _ref4$totals.videoViews,
      trackedAssetsStats = _ref4.trackedAssetsStats;
  return _react2.default.createElement(
    _semanticUiReact.Table.Row,
    { key: id },
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_semanticUiReact.Image, {
        src: thumbnail,
        className: 'circular',
        style: avatarStyle
      }),
      _react2.default.createElement(
        'span',
        { style: influencerNameStyle },
        influencerName
      ),
      _react2.default.createElement('br', null),
      _react2.default.createElement(
        'span',
        { style: influnecerHandleStyle },
        name
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      _react2.default.createElement(_roiReport.RowAssets, trackedAssetsStats)
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'center' },
      instagramCount ? (0, _formatting.commaFormatted)(instagramCount) : '-'
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'center' },
      reach ? (0, _formatting.commaFormatted)(reach) : '-'
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'center' },
      impressions ? (0, _formatting.commaFormatted)(impressions) : '-'
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'center' },
      videoViews ? (0, _formatting.commaFormatted)(videoViews) : '-'
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'center' },
      engagements ? (0, _formatting.commaFormatted)(engagements) : '-'
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'center' },
      instagramEngagementFactor ? (0, _formatting.percentFormatted)(instagramEngagementFactor) : '-'
    )
  );
};

ReportRow.propTypes = {
  id: _propTypes2.default.string.isRequired,
  name: _propTypes2.default.string.isRequired,
  instagramCount: _propTypes2.default.number.isRequired,
  instagramEngagementFactor: _propTypes2.default.number.isRequired,
  totals: _propTypes2.default.object.isRequired,
  trackedAssetsStats: _propTypes2.default.object.isRequired,
  thumbnail: _propTypes2.default.string.isRequired,
  influencerName: _propTypes2.default.string.isRequired
};

var reverseOrder = function reverseOrder() {
  var order = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'asc';

  if (order === 'asc') {
    return 'desc';
  }
  return 'asc';
};

var API_URL = 'https://ms6w6cj6i8.execute-api.eu-west-1.amazonaws.com/production/report/super/';

var influencerDropdownStyle = {};

var getAuthStatusLabel = function getAuthStatusLabel(value) {
  return value ? 'authorised' : 'not authorised';
};

var SuperReport = function (_Component) {
  (0, _inherits3.default)(SuperReport, _Component);

  function SuperReport(props) {
    var _this2 = this;

    (0, _classCallCheck3.default)(this, SuperReport);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SuperReport.__proto__ || (0, _getPrototypeOf2.default)(SuperReport)).call(this, props));

    _this.componentDidMount = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var data;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              data = _this.props.data;

              console.log(_this.props);
              if (data) {
                console.log(data);
                _this.setState({
                  loading: false,
                  data: _lodash2.default.get(data, 'reportData'),
                  metadata: _lodash2.default.get(data, 'metadata'),
                  campaignInfo: _lodash2.default.get(data, 'firstCampaign')
                });
              } else {
                _this.loadReport();
              }

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));

    _this.onSortFieldChange = function (field) {
      _this.setState({
        sort: {
          field: field,
          order: reverseOrder(_this.state.sort.order)
        }
      });
    };

    _this.onFilterChange = function (event, _ref6) {
      var name = _ref6.name,
          value = _ref6.value;
      var filter = _this.state.filter;

      var updatedFilter = _lodash2.default.cloneDeep(filter);
      if (_lodash2.default.isUndefined(value)) {
        _lodash2.default.unset(updatedFilter, name);
      } else {
        _lodash2.default.set(updatedFilter, name, value);
      }
      _this.setState({
        filter: updatedFilter
      }, _this.loadReport);
    };

    _this.onDateFilterChange = function (date, dateType) {
      var dateFilter = _this.state.dateFilter;

      var filterClone = _lodash2.default.clone(dateFilter);
      _lodash2.default.set(filterClone, dateType, date);
      _this.setState({
        dateFilter: filterClone
      }, _this.loadReport);
    };

    _this.getFilteredData = function (rows) {
      var filter = _this.state.filter;

      return _lodash2.default.isEmpty(filter) ? rows : _lodash2.default.filter(rows, filter);
    };

    _this.loadReport = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
      var campaignCode, dateFilter, validFilterDate, url, _ref8, data;

      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              campaignCode = _this.props.campaignCode;
              dateFilter = _this.state.dateFilter;
              validFilterDate = _lodash2.default.isDate(dateFilter.start) && _lodash2.default.isDate(dateFilter.end);
              url = validFilterDate ? '' + API_URL + campaignCode + '?fromDate=' + new Date(dateFilter.start).toISOString() + '&toDate=' + new Date(dateFilter.end).toISOString() : '' + API_URL + campaignCode;
              _context2.next = 6;
              return _axios2.default.get(url).catch(function () {
                _this.setState({
                  failed: true,
                  loading: false,
                  campaignInfo: null,
                  data: null,
                  metadata: null
                });
              });

            case 6:
              _ref8 = _context2.sent;
              data = _ref8.data;

              if (data) {
                _this.setState({
                  loading: false,
                  data: _lodash2.default.get(data, 'reportData'),
                  metadata: _lodash2.default.get(data, 'metadata'),
                  campaignInfo: _lodash2.default.get(data, 'firstCampaign')
                });
              }

            case 9:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));

    _this.resetDateFilter = function () {
      _this.setState({
        dateFilter: {}
      }, _this.loadReport);
    };

    _this.state = {
      loading: true,
      failed: false,
      data: null,
      filter: {},
      dateFilter: {},
      sort: {
        field: 'totals.engagements',
        order: 'desc'
      }
    };
    return _this;
  }

  (0, _createClass3.default)(SuperReport, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          sort = _state.sort,
          loading = _state.loading,
          failed = _state.failed,
          data = _state.data,
          filter = _state.filter,
          campaignInfo = _state.campaignInfo;


      if (loading) {
        return _react2.default.createElement(_semanticUiReact.Loader, { active: true, content: 'Loading report...' });
      }

      if (failed) {
        return _react2.default.createElement(_semanticUiReact.Message, { content: 'Failed to load report. Please try again later.', negative: true });
      }

      var campaignCode = this.props.campaignCode;

      var isEmptyReport = _lodash2.default.isEmpty(data);

      var staticRows = _lodash2.default.clone(data);

      var reportRows = this.getFilteredData(data);

      var csvValues = _lodash2.default.map(reportRows, function (item) {
        return {
          influencer: _lodash2.default.get(item, 'name'),
          followers: _lodash2.default.get(item, 'instagramCount', 0),
          posts: _lodash2.default.get(item, 'trackedAssetsStats.instagram.images', 0),
          videos: _lodash2.default.get(item, 'trackedAssetsStats.instagram.videos', 0),
          stories: _lodash2.default.get(item, 'trackedAssetsStats.instagram.stories', 0),
          igtvs: _lodash2.default.get(item, 'trackedAssetsStats.instagram.igtvs', 0),
          views: _lodash2.default.get(item, 'totals.videoViews', 0),
          reach: _lodash2.default.get(item, 'totals.reach', 0),
          impressions: _lodash2.default.get(item, 'totals.impressions', 0),
          engagements: _lodash2.default.get(item, 'totals.engagements', 0),
          engagementsRate: (0, _formatting.percentFormatted)(item.instagramEngagementFactor)
        };
      });

      var timestamp = (0, _moment2.default)().format('YYYY-MM-DD');
      var csvFileName = _lodash2.default.kebabCase(campaignCode) + '-super-report-' + timestamp + '.csv';

      var sortedReportRows = _lodash2.default.orderBy(reportRows, [sort.field], [sort.order]);

      var totals = (0, _emvUtils.getTotals)(staticRows);

      var headerInfo = {
        info: {
          campaignName: _lodash2.default.replace(_lodash2.default.get(campaignInfo, 'name'), /\(\d\)/, ''),
          hashtags: _lodash2.default.get(campaignInfo, 'hashtags')
        }
      };

      var inputStyle = {
        margin: 5
      };

      var dateFilter = this.state.dateFilter;


      var isResetDateFilterButtonDisabled = !_lodash2.default.isDate(dateFilter.start) || !_lodash2.default.isDate(dateFilter.end);

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _semanticUiReact.Card,
          { color: 'pink', fluid: true },
          _react2.default.createElement(
            _semanticUiReact.Card.Content,
            null,
            _react2.default.createElement(_reportHeader2.default, headerInfo)
          )
        ),
        _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
        isEmptyReport && _react2.default.createElement(_semanticUiReact.Message, { content: 'No data for this report yet' }),
        !isEmptyReport && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _semanticUiReact.Segment,
            null,
            _react2.default.createElement(_summaryTable2.default, { rows: staticRows, totals: totals })
          ),
          _react2.default.createElement(
            _semanticUiReact.Menu,
            null,
            _react2.default.createElement(
              _semanticUiReact.Menu.Menu,
              null,
              _react2.default.createElement(
                _semanticUiReact.Menu.Item,
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  'FILTER BY:'
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Menu.Menu,
              null,
              _react2.default.createElement(
                _semanticUiReact.Dropdown,
                {
                  scrolling: true,
                  item: true,
                  text: _lodash2.default.has(filter, 'name') ? _lodash2.default.get(filter, 'name') : 'influencer'
                },
                _react2.default.createElement(
                  _semanticUiReact.Dropdown.Menu,
                  { style: influencerDropdownStyle },
                  _lodash2.default.has(filter, 'name') && _react2.default.createElement(
                    _semanticUiReact.Dropdown.Item,
                    {
                      onClick: function onClick(event) {
                        return _this3.onFilterChange(event, { name: 'name' });
                      }
                    },
                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', size: 'tiny' }),
                    'reset'
                  ),
                  _lodash2.default.map(data, function (_ref9) {
                    var name = _ref9.name;
                    return _react2.default.createElement(
                      _semanticUiReact.Dropdown.Item,
                      {
                        onClick: function onClick(event) {
                          return _this3.onFilterChange(event, { name: 'name', value: name });
                        },
                        value: 'discussion'
                      },
                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'user', size: 'tiny' }),
                      ' ',
                      _lodash2.default.toLower(name)
                    );
                  })
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Menu.Menu,
              null,
              _react2.default.createElement(
                _semanticUiReact.Dropdown,
                {
                  scrolling: true,
                  item: true,
                  text: _lodash2.default.has(filter, 'instagramAuthorised') ? getAuthStatusLabel(_lodash2.default.get(filter, 'instagramAuthorised')) : 'authorisation status'
                },
                _react2.default.createElement(
                  _semanticUiReact.Dropdown.Menu,
                  null,
                  _lodash2.default.has(filter, 'instagramAuthorised') && _react2.default.createElement(
                    _semanticUiReact.Dropdown.Item,
                    {
                      onClick: function onClick(event) {
                        return _this3.onFilterChange(event, { name: 'instagramAuthorised' });
                      }
                    },
                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', size: 'tiny' }),
                    'reset'
                  ),
                  _lodash2.default.map(['authorised', 'not authorised'], function (status) {
                    return _react2.default.createElement(
                      _semanticUiReact.Dropdown.Item,
                      {
                        onClick: function onClick(event) {
                          return _this3.onFilterChange(event, { name: 'instagramAuthorised', value: status === 'authorised' });
                        }
                      },
                      _react2.default.createElement(_semanticUiReact.Icon, { name: status === 'authorised' ? 'checkmark' : 'ban', size: 'tiny' }),
                      ' ',
                      _lodash2.default.toLower(status)
                    );
                  })
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Menu.Menu,
              null,
              _react2.default.createElement(_DayPickerInput2.default, {
                component: function component(p) {
                  return _react2.default.createElement(
                    'div',
                    { style: inputStyle, className: 'ui input' },
                    _react2.default.createElement('input', p)
                  );
                },
                onDayChange: function onDayChange(day) {
                  return _this3.onDateFilterChange(day, 'start');
                },
                format: DATE_PICKER_DATE_FORMAT,
                dateFormat: DATE_PICKER_DATE_FORMAT,
                placeholder: 'Start date',
                formatDate: _moment3.formatDate,
                parseDate: _moment3.parseDate,
                value: dateFilter.start
              }),
              _react2.default.createElement(_DayPickerInput2.default, {
                component: function component(p) {
                  return _react2.default.createElement(
                    'div',
                    { style: inputStyle, className: 'ui input' },
                    _react2.default.createElement('input', p)
                  );
                },
                onDayChange: function onDayChange(day) {
                  return _this3.onDateFilterChange(day, 'end');
                },
                format: DATE_PICKER_DATE_FORMAT,
                dateFormat: DATE_PICKER_DATE_FORMAT,
                placeholder: 'End date',
                formatDate: _moment3.formatDate,
                parseDate: _moment3.parseDate,
                value: dateFilter.end
              }),
              _react2.default.createElement(
                _semanticUiReact.Menu.Item,
                null,
                _react2.default.createElement(_semanticUiReact.Button, {
                  onClick: this.resetDateFilter,
                  className: 'circular',
                  icon: 'x',
                  disabled: isResetDateFilterButtonDisabled
                })
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Menu.Item,
              { position: 'right' },
              _react2.default.createElement(
                _semanticUiReact.Label,
                { basic: true, size: 'large', color: 'pink' },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'file excel outline' }),
                _react2.default.createElement(
                  _reactCsv.CSVLink,
                  { data: csvValues, filename: csvFileName },
                  'Download Report'
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Menu.Item,
              null,
              !isVoxogram && _react2.default.createElement(_semanticUiReact.Button, { color: 'pink', inverted: true, size: 'tiny', circular: true, icon: 'help', onClick: goToHelpPage })
            )
          ),
          !_lodash2.default.isEmpty(filter) && _lodash2.default.isEmpty(reportRows) && _react2.default.createElement(
            _semanticUiReact.Message,
            { warning: true },
            'No records found based on your filter.'
          ),
          !_lodash2.default.isEmpty(reportRows) && _react2.default.createElement(
            _semanticUiReact.Card,
            { fluid: true, color: 'green' },
            _react2.default.createElement(
              _semanticUiReact.Table,
              { sortable: true, basic: 'very', singleLine: true, celled: true, style: tableStyle },
              _react2.default.createElement(ReportTableHeader, {
                onSortChanged: this.onSortFieldChange,
                sort: sort
              }),
              _react2.default.createElement(
                _semanticUiReact.Table.Body,
                null,
                _lodash2.default.map(sortedReportRows, function (row) {
                  return _react2.default.createElement(ReportRow, (0, _extends3.default)({ key: (0, _uuid2.default)() }, row));
                }),
                _react2.default.createElement(TotalsRow, { rows: reportRows })
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Card.Content,
              { extra: true },
              _react2.default.createElement(
                'div',
                { className: 'ui right aligned' },
                'Report generated at ',
                _react2.default.createElement(
                  'strong',
                  null,
                  (0, _moment2.default)().format('MMMM Do YYYY, h:mm a')
                ),
                '.'
              )
            )
          )
        )
      );
    }
  }]);
  return SuperReport;
}(_react.Component);

exports.default = SuperReport;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dyzio-shared-components/lib/reports/super-report/index.js
// module id = 2275
// module chunks = 1